module.exports = __webpack_public_path__ + "img/gridHeaderLeft.dc0067c9.svg";